import { BookOutlined } from '@ant-design/icons'
import { Tag, Tooltip } from 'antd'
import { useCallback } from 'react'
import {
	ListPageIntro,
	ListPageShell,
	ListPageTotal,
	PagedResourceList,
} from '../../common'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { onGetWords } from '../../redux/word/word.action'

const columns = [
	{
		title: 'Word',
		dataIndex: 'word',
		key: 'word',
	},
	{
		title: 'Username',
		dataIndex: 'authName',
		key: 'authName',
	},
	{
		title: 'Definition',
		dataIndex: 'definition',
		key: 'definition',
	},
	{
		title: 'Context',
		dataIndex: 'latestSaveContext',
		key: 'latestSaveContext',
		width: 420,
		ellipsis: true,
		render: value => {
			const context = typeof value === 'string' ? value.trim() : ''
			if (!context) return '—'
			return (
				<Tooltip title={context}>
					<span>{context}</span>
				</Tooltip>
			)
		},
	},
	{
		title: 'Save Type',
		dataIndex: 'latestSaveType',
		key: 'latestSaveType',
		width: 120,
		render: value => {
			const saveType = typeof value === 'string' ? value.trim() : ''
			if (!saveType) return '—'

			const normalized = saveType.toLowerCase()
			let color = 'default'
			if (normalized === 'save') color = 'green'
			else if (normalized === 'update') color = 'blue'
			else if (normalized === 'manual') color = 'purple'

			return <Tag color={color}>{saveType}</Tag>
		},
	},
	{
		title: 'Saved At',
		dataIndex: 'latestSaveAt',
		key: 'latestSaveAt',
		width: 180,
		render: value => {
			if (!value) return '—'
			const raw =
				typeof value === 'string'
					? value
					: value?.Time || value?.time || value?.String || value?.string
			if (!raw) return '—'
			const date = new Date(raw)
			if (Number.isNaN(date.getTime())) return '—'
			return date.toLocaleString()
		},
	},
	{
		title: 'Created By',
		dataIndex: 'createdBy',
		key: 'createdBy',
	},
	{
		title: 'Source Url',
		dataIndex: 'sourceUrl',
		key: 'sourceUrl',
		render: sourceUrl => {
			if (sourceUrl == null || sourceUrl === '') return '—'
			if (typeof sourceUrl === 'string') return sourceUrl
			if (typeof sourceUrl === 'object') {
				return (
					sourceUrl.String ??
					sourceUrl.string ??
					sourceUrl.url ??
					'—'
				)
			}
			return String(sourceUrl)
		},
	},
]

export const WordList = () => {
	const dispatch = useAppDispatch()
	const word = useAppSelector(state => state.word)
	const fetchPage = useCallback(
		(page, cb) => dispatch(onGetWords(page, cb)),
		[dispatch]
	)

	const topLeft = (
		<ListPageIntro
			icon={BookOutlined}
			title="Words"
			subtitle="User-submitted words and definitions from the app."
		/>
	)

	return (
		<ListPageShell>
			<PagedResourceList
				resource={word}
				columns={columns}
				fetchPage={fetchPage}
				rowKey={record => record.id}
				headerClassName="list-page-bar"
				topLeft={topLeft}
				topRight={<ListPageTotal total={word?.total} />}
				tableProps={{ scroll: { x: 1900 } }}
			/>
		</ListPageShell>
	)
}
